import * as React from 'react'
import * as Types from '../../../declarations'

const TableOfContents = ({
	trip: {
		jsonData: { trekOrClimb, guidedLinks },
		jsonData,
		similarTrips,
	},
	trip,
}: {
	trip: Types.DB.Models.TripAttributes
}) => {
	const isTrek = trekOrClimb === 'TREK'
	const isClimb = !isTrek

	const toc: { displayText: string; target: string }[] = React.useMemo(() => {
		const draftToc = []

		// guideLinks
		// if ((jsonData?.guidedLinks ?? []).length > 0) {
		if (
			(trip?.guideTrips ?? []).length > 0 ||
			(guidedLinks?.length ?? []) > 0
		) {
			draftToc.push({
				displayText: `${trip.name} Guides`,
				target: '#guides',
			})
		}

		// history
		if (!!jsonData?.history && isClimb) {
			draftToc.push({
				displayText: 'History',
				target: '#history',
			})
		}

		// pictures
		if ((trip?.uploads ?? []).length > 5) {
			draftToc.push({
				displayText: 'Pictures',
				target: '#pictures',
			})
		}

		// itinerary
		if (isTrek && (jsonData?.itinerary?.days ?? []).length > 0) {
			draftToc.push({
				displayText: 'Itinerary',
				target: '#itinerary',
			})
		}
		if (isClimb && (jsonData?.itinerary?.climbSections ?? []).length > 0) {
			draftToc.push({
				displayText: 'Itinerary',
				target: '#itinerary',
			})
		}

		// route
		if (
			(jsonData?.route?.locations ?? []).length > 0 ||
			(jsonData?.route?.routeLines ?? []).length > 0
		) {
			draftToc.push({
				displayText: 'Route',
				target: '#route_map',
			})
		}

		// difficulty
		if (
			isTrek &&
			Object.values(jsonData?.trekDifficulty?.individualScores ?? []).filter(
				(val) => !!val,
			).length === 7
		) {
			draftToc.push({
				displayText: 'Difficulty',
				target: '#difficulty',
			})
		}
		// if (isClimb && (jsonData?.climbDifficulty?.simple ?? []).length === 7) {
		// 	draftToc.push({
		// 		displayText: 'Difficulty',
		// 		target: '#difficulty',
		// 	})
		// }

		// weather
		if (
			(jsonData?.weather?.monthlyWeatherData ?? []).length > 0 ||
			!!jsonData?.weather?.description
		) {
			draftToc.push({
				displayText: 'Weather',
				target: '#weather',
			})
		}

		// gear
		if (!!jsonData?.gear?.description && isClimb) {
			draftToc.push({
				displayText: 'Gear',
				target: '#gear',
			})
		}

		// services
		if (
			Object.values(jsonData?.services ?? {}).filter((val) => !!val).length > 0
		) {
			draftToc.push({
				displayText: 'Services',
				target: '#services',
			})
		}

		// accommodation
		if (
			(isTrek && !!jsonData?.accommodation?.description) ||
			(jsonData?.accommodation?.types ?? []).length > 0
		) {
			draftToc.push({
				displayText: 'Accommodation',
				target: '#accommodation',
			})
		}

		// permits
		if (
			!!jsonData?.permits?.description ||
			(jsonData?.permits?.permits ?? []).length > 0
		) {
			draftToc.push({
				displayText: 'Permits',
				target: '#permits',
			})
		}

		// access
		if (jsonData?.access?.description) {
			draftToc.push({
				displayText: 'Access',
				target: '#access',
			})
		}

		// videos
		if ((jsonData?.videos ?? []).length > 0) {
			draftToc.push({
				displayText: 'Videos',
				target: '#videos',
			})
		}

		// summit view
		if (
			isClimb &&
			(
				jsonData?.route?.locations?.filter(
					(location) => location.type === 'summit',
				) ?? []
			).length > 0
		) {
			draftToc.push({
				displayText: 'Summit View',
				target: '#summit_view',
			})
		}

		// variations
		if ((jsonData?.variations ?? []).length > 0) {
			draftToc.push({
				displayText: 'Variations',
				target: '#variations',
			})
		}

		// faqs
		if ((jsonData?.faqs ?? []).length > 0) {
			draftToc.push({
				displayText: 'FAQs',
				target: '#faqs',
			})
		}

		// groups
		if ((jsonData?.groups ?? []).length > 0) {
			draftToc.push({
				displayText: 'Links',
				target: '#links',
			})
		}

		// similar
		if ((similarTrips ?? []).length > 0) {
			draftToc.push({
				displayText: 'Similar',
				target: '#similar',
			})
		}

		return draftToc
	}, [trip])

	if (toc.length === 0) {
		return <></>
	}

	return (
		<div id="table-of-contents" className="spacing-between-sections-above">
			<h2>Table of contents</h2>
			{toc.map((section, i) => (
				<div key={i}>
					<a key={i} href={section.target}>
						{section.displayText}
					</a>
				</div>
			))}
		</div>
	)
}

export default TableOfContents
